import styled from 'styled-components';

const menuBtnSize = '50px';
const menuBtnSizeReduced = '45px';
const percentageSize = 1.3;

export const CatalogBtnContainer = styled.div`
  background: transparent;
  display: ${(props) => (props.hideBottomButtons ? 'none' : 'block')};
  position: absolute;
  z-index: 2;
  align-items: center;
  bottom: ${(props) => props.alturaBtnCataleg};
  left: 0;
  padding: 0 10px;
  color: white;
`;

export const CatalogBtnWrapper = styled.div``;

export const CatalogIconBtnWrapper = styled.div`
  display: flex;
  text-align: center;
  margin: auto;
  height: 60px;
  width: 100%;
  padding: 2px;
`;

export const CatalogIconBtn = styled.button`
  display: flex;
  border-radius: 50%;
  height: ${menuBtnSizeReduced};
  justify-content: center;
  align-items: center;
  border: 0;
  margin: auto;
  width: ${menuBtnSizeReduced};
  z-index: 2;
  background-color: ${({ catalogOpen }) => (catalogOpen ? '#febf00' : '#c00000')};
  animation: ${({ selected }) => (selected ? 'CatalogActive 0.01s ease-out forwards' : 'CatalogNotActive 0.01s ease-out forwards')};

  @media screen and (max-width: 768px) {
    height: ${menuBtnSize};
    width: ${menuBtnSize};
  }
`;

export const CatalogContainer = styled.div`
  display: ${({ catalogOpen }) => (catalogOpen ? 'inline-block' : 'none')};

  background-color: rgba(51, 51, 51, 0.85);
  position: absolute;
  height: 75%;
  z-index: 1;
  width: 520px;
  bottom: calc(${(props) => props.alturaBtnCataleg} + 5px);
  left: 10px;
  border-radius: 10px;
  border-bottom-left-radius: 35px;
  max-height: ${({ alturaBtnCataleg }) => `calc(100vh - 110px - ${alturaBtnCataleg})`};
  align-items: center;
  justify-content: center;
  vertical-align: middle;

  ::-webkit-scrollbar {
    width: 7px;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #333333;
  }

  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 5px;
  }

  @media screen and (max-width: 768px) {
    max-height: 100%;
    border-radius: 0px;
    z-index: 9;
    overflow-y: auto;
    bottom: 0;
    left: 0;
    width: 100%;
    height: ${(props) => (props.displayNav ? `${parseInt(props.mapHeight)}px` : `${parseInt(props.mapHeight) + 80}px`)};
  }
`;

export const CatalogWrapper = styled.div`
  height: 100%;

  @media screen and (max-width: 768px) {
    height: auto;
  }
`;

export const CatalogHeader = styled.div`
  border-bottom: 1.5px solid transparent;
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  z-index: 4;
  margin-left: 10px;

  @media screen and (max-height: 400px) {
    margin-left: 5%;
    margin-right: 5%;
  }

  @media screen and (max-width: 768px) {
    overflow-y: hidden;
    width: 95%;
    height: 110%;
    margin-left: 10px;
    ::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
  }
`;

export const CatalogTitleContainer = styled.div`
  height: 100%;
`;

export const CatalogTitleWrapper = styled.div`
  width: fit-content;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  box-sizing: content-box;
  white-space: nowrap;
  height: 40px;

  @media screen and (max-width: 768px) {
    margin-left: 0px;
  }
`;

export const CatalogTitle = styled.h3`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  width: fit-content;
  box-sizing: inherit;
  margin: 0;
  z-index: 1;
  padding-right: 15px;
  height: 100%;
  padding-left: 15px;
  /* font-weight: ${(props) => (props.selected ? '500' : '200')}; */
  line-height: 1.2;
  color: ${(props) => (props.selected ? '#febf00' : 'white')};
  cursor: pointer;
  border-bottom: ${(props) => (props.selected ? '4px solid #febf00;' : 'none')};

  @media screen and (max-width: 768px) {
    height: 92%;
  }
`;

export const CatalogCloseBtn = styled.button`
  background: transparent;
  display: none;
  color: white;
  opacity: 90%;
  border-radius: 50%;
  border: 0;
  padding-right: 1%;
  box-sizing: border-box;
  text-align: right;
  position: absolute;
  right: 0;
  @media screen and (max-width: 464px) {
    display: none;
  }
`;

export const CatalogCloseBtnIcon = styled.img`
  vertical-align: top;
  height: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  width: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
`;
export const CatalogInfoWrapper = styled.div`
  margin-right: 5%;
  @media screen and (max-width: 768px) {
    margin-right: 0;
  }
`;
export const CatalogResultsContainer = styled.div`
  margin-left: 5%;
  margin-right: 1px;
  padding-left: 5px;
  color: white;
  overflow-y: auto;
  height: calc(100% - 100px);
  display: ${({ isCat }) => (isCat ? 'block' : 'none')};

  ::-webkit-scrollbar {
    width: 7px;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #333333;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 5px;
  }

  @media screen and (max-height: 400px) {
    margin-left: 5%;
    margin-right: 5%;
  }

  @media screen and (max-width: 768px) {
    height: auto;
    margin: 0;
    padding-left: 10px;
    padding-right: 10px;
    overflow-y: auto;
    height: calc(100vh - 200px);
  }
`;

export const HeaderWrapper = styled.div``;

export const HeaderTitle = styled.h3`
  margin: 0;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  font-weight: bold;
  margin-top: 25px;
`;

export const HeaderDescription = styled.div`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  margin-top: ${({ marginTop }) => (marginTop ? 'none' : '10px')};
`;

export const SearchIconButton = styled.button`
  background-color: white;
  border: 0px;
  display: flex;
  align-items: center;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
`;

export const SearchIcon = styled.img`
  vertical-align: middle;
  margin-top: auto;
  margin-bottom: auto;
  text-align: center;
`;
export const GraySearchButton = styled.button`
  background-color: white;
  color: gray;
  border: 0px;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
`;
export const SearcherInput = styled.input`
  height: 28px;
  vertical-align: middle;
  border: 0px;
  min-width: 24px;
  display: flex;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 13 * percentageSize : 13)}px;
  flex: 1;

  &:focus {
    border: 0;
    border-color: transparent;
    box-shadow: 0 0 0 0.25rem rgb(13 110 253 / 0%);
  }
`;

export const FormInput = styled.div`
  display: flex;
  flex-direction: row;

  margin-top: ${({ marginTop }) => (marginTop ? '10px' : '0px')};
  margin-bottom: 0.5rem;
  text-align: center;
  vertical-align: middle;
  width: 100%;

  @media screen and (max-width: 768px) {
    width: 100%;
    margin-top: 0.5rem;
  }

  :hover {
    box-shadow: 0 0px 7px #febf00dd;
  }
`;

export const ButtonsWrapper = styled.div`
  margin-bottom: 10px;
`;

export const OptionsButton = styled.button`
  color: white;
  background-color: #333333;
  opacity: 90%;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  padding-right: 10px;
  margin-right: 10px;
  padding: 3px 10px;
  text-align: center;
  vertical-align: middle;
  border-radius: 0.5em;
  border: none;

  :hover {
    box-shadow: 0 0px 7px #febf00dd;
  }

  @media screen and (max-width: 768px) {
    width: 48%;
    margin-right: 0;
    margin-left: ${({ margin }) => (margin ? '4%' : '0px')};
  }
`;

export const SeparatorRow = styled.div`
  content: '';
  background-color: #b7b7b7;
  width: 98%;
  height: 2px;
  margin-left: auto;
  margin-right: auto;
  opacity: 80%;
  @media screen and (max-width: 768px) {
    position: absolute;
    top: 38px;
  }
`;

export const LayerSeparatorRow = styled.div`
  content: '';
  background-color: #b7b7b7;
  width: 60%;
  height: 1px;
  opacity: 80%;
  margin-bottom: 5px;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const LayersContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  /* height: calc(${(props) => props.mapHeight} - 207px - 25vh); */
  /* height: 75%; */

  ::-webkit-scrollbar {
    width: 7px;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #333333;
  }

  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 5px;
  }

  @media screen and (max-width: 768px) {
    overflow-y: auto;
    height: calc(${(props) => props.mapHeight} - 350px);
    overflow-y: revert;
  }
`;

export const TornarAlMapaButton = styled.button`
  margin-top: 15px;
  display: none;
  margin-bottom: 15px;
  height: 32px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  background: #c00000;
  color: white;
  padding: 3px 25px;
  border: none;
  text-align: center;
  vertical-align: middle;
  border-radius: 0.5em;
  font-weight: bold;

  @media screen and (max-width: 768px) {
    display: block;
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
    width: 100%;
    margin-left: 10px;
    margin-right: 10px;
    padding: 5px 25px;
  }
`;

export const CatalogFoot = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
`;
export const ButtonWrapperFooter = styled.div`
  width: 100%;
  display: flex;
  padding-left: 5%;
  justify-content: flex-start;

  @media screen and (max-width: 768px) {
    justify-content: center;
    padding-left: 0px;
  }
`;

export const LoaderResultsContainer = styled.div`
  margin-left: 5%;
  margin-right: 1px;
  padding-left: 5px;
  color: white;
  overflow-y: auto;
  height: calc(100% - 100px);
  display: ${({ isExt }) => (isExt ? 'block' : 'none')};

  ::-webkit-scrollbar {
    width: 7px;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #333333;
  }

  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 5px;
  }
  @media screen and (max-height: 400px) {
    margin: 0 5% 0 5%;
  }
  @media screen and (max-width: 768px) {
    padding-left: 10px;
    padding-right: 10px;
    margin: 0;
    overflow-y: auto;
    height: calc(100vh - 200px);
  }
`;

export const UserResultsContainer = styled.div`
  margin-left: 5%;
  padding-left: 5px;
  color: white;
  overflow-y: auto;
  margin-right: 1px;
  height: calc(100% - 100px);
  display: ${({ isUser }) => (isUser ? 'block' : 'none')};

  ::-webkit-scrollbar {
    width: 7px;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #333333;
  }

  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 5px;
  }
  @media screen and (max-height: 400px) {
    margin: 0 5% 0 5%;
  }
  @media screen and (max-width: 768px) {
    padding-left: 10px;
    padding-right: 10px;
    margin: 0;
    height: calc(100vh - 250px);
  }
`;

export const LoaderButtonsWrapper = styled.div`
  margin-top: 5px;
`;

export const DeleteSearchIconButton = styled.button`
  background-color: white;
  border: 0px;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  cursor: ${({ text }) => (text ? 'pointer' : 'default')}!important;

  :hover {
    filter: hue-rotate(90deg);
  }
`;
export const DeleteSearchIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 24 24',
  width: props.fontSizeEnabled ? 22 * percentageSize : 22,
  height: props.fontSizeEnabled ? 22 * percentageSize : 22
}))`
  fill: ${({ text }) => (text ? 'black' : 'white')};
`;

export const AddWMSButton = styled.button`
  background: #666666;
  color: #fff;
  padding: 3px 10px;
  width: 50%;
  text-align: center;
  vertical-align: middle;
  border-radius: 0.5em;
  margin-bottom: 10px;
  border-width: thin;
  display: inline-flex;
  border: none;
  align-items: center;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;

  :hover {
    box-shadow: 0 0px 7px #febf00dd;
  }

  @media screen and (max-width: 768px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
    width: 100%;
    margin-left: 0;
    margin-bottom: 0px;
  }
`;

export const LoadLocalButton = styled.button`
  background-color: #666666;
  color: #fff;
  border-color: #333333;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  padding: 3px 10px;
  text-align: center;
  width: 50%;
  vertical-align: middle;
  border-radius: 0.5em;
  border-width: thin;
  display: inline-flex;
  border: none;
  align-items: center;
  :hover {
    box-shadow: 0 0px 7px #febf00dd;
  }
  @media screen and (max-width: 768px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
    width: 100%;
  }
`;

export const LoaderWrapper = styled.div`
  display: block;
`;

export const ButtonText = styled.p`
  padding: 0px;
  margin: 0px;
  margin-left: ${({ marginLeft }) => (marginLeft ? '10px' : '0px')};
`;

export const ExternalLayersWrapper = styled.div`
  max-height: calc(${(props) => props.mapHeight} - 425px);
  /* overflow-y: auto; */

  ::-webkit-scrollbar {
    width: 7px;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #333333;
  }

  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 5px;
  }

  @media screen and (max-width: 768px) {
    max-height: calc(${(props) => props.mapHeight} - 460px);
    overflow-y: revert;
  }
`;

export const UserLayersWrapper = styled.div`
  max-height: calc(${(props) => props.mapHeight} - 740px);

  @media screen and (max-width: 855px) {
    max-height: calc(${(props) => props.mapHeight} - 520px);
  }

  @media screen and (max-width: 821px) {
    max-height: calc(${(props) => props.mapHeight} - 540px);
  }

  @media screen and (max-width: 804px) {
    max-height: calc(${(props) => props.mapHeight} - 560px);
  }

  @media screen and (max-width: 768px) {
    max-height: calc(${(props) => props.mapHeight} - 460px);
  }
`;

export const ButtonContentWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
`;

export const OvalContainer = styled.div`
  display: flex;
  margin-right: 5%;
  margin-top: 50px;
  justify-content: center;

  @media screen and (max-height: 400px) {
    margin-top: 10px;
    margin-right: auto;
  }

  @media screen and (max-width: 768px) {
    margin-right: 0%;
  }
`;
export const OvalContainerEXT = styled.div`
  display: flex;
  margin-left: 210px;
  margin-top: 50px;

  @media screen and (max-width: 768px) {
    margin-top: 10px;
    margin-left: 0;
    justify-content: center;
  }

  @media screen and (max-height: 400px) {
    margin-left: 0;
    justify-content: center;
  }
`;

export const CatalegSVG15 = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 15 * percentageSize : 15,
  height: props.fontSizeEnabled ? 15 * percentageSize : 15
}))``;

export const CatalegSVG16 = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 16 * percentageSize : 16,
  height: props.fontSizeEnabled ? 16 * percentageSize : 16
}))``;

export const CatalegSVG24 = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;
export const CatalegSVG28 = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 26 * percentageSize : 26,
  height: props.fontSizeEnabled ? 26 * percentageSize : 26
}))``;
